import { benefitsGateway, deductionsGateway } from './index';
import type { BenefitPlan, DeductionDefinition, Paged } from './types';

const PAGE = 100;

/** Follows every page of a list (the API caps a page at 100), for pickers and joins that need the whole set. */
async function loadAll<T>(fetchPage: (page: number) => Promise<Paged<T>>): Promise<T[]> {
  const all: T[] = [];
  let page = 1;
  for (;;) {
    const result = await fetchPage(page);
    all.push(...result.items);
    if (result.items.length === 0 || all.length >= result.totalCount) return all;
    page += 1;
  }
}

export function loadAllPlans(): Promise<BenefitPlan[]> {
  return loadAll((page) => benefitsGateway.listPlans({ page, pageSize: PAGE, sort: 'name' }));
}

export function loadAllDefinitions(): Promise<DeductionDefinition[]> {
  return loadAll((page) => deductionsGateway.listDefinitions({ page, pageSize: PAGE, sort: 'name' }));
}
